import { type FC, type ReactNode } from "react";

// One quiet line over a pane: a sentence, then any action as a link.
export const NoticeLine: FC<{ children: ReactNode }> = ({ children }) => (
  <p className="pb-2 text-[13px] text-slate-500">{children}</p>
);
